<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96"
  >
    <path
      d="m15.97,42.29c4.76-13.09,17.3-22.44,32.03-22.45,11.56,0,21.78,5.75,27.95,14.55l5.23.83c-6.53-11.57-18.94-19.38-33.17-19.38h-.01c-18.41,0-33.76,13.05-37.32,30.4l5.29-3.95Z"
      fill="#4f2b1b"
    />
    <path
      d="m63.12,60.32c-3.73-6.49,5.76-3.52,8.56-5.13,3.48-2,1.59-6.33.74-9.25-.57-1.97-.67-4.49.8-6.19,2.8-3.25,7.09-.07,9.1,2.54,3.1,4.03,2.68,9.23.35,13.51-3.43,6.31-14.32,11.84-19.56,4.53-.47-.66-1.47.1-.99.77,4.61,6.43,13.81,3.95,18.76-.82,4.77-4.59,6.78-12.53,2.82-18.21-3.36-4.88-11.3-7.81-12.79.1-.54,2.86,1,4.94,1.43,7.66.69,4.28-2.39,4.56-5.61,4.62-4.51.08-7.07,2.32-4.58,6.65.39.67,1.4-.08.96-.77Z"
      fill="#4f2b1b"
      stroke="#4f2b1b"
      stroke-miterlimit="10"
      stroke-width=".75"
    />
    <path
      d="m79.23,41.31c-.56-.58-1.57.18-1,.76,1.99,2.03,3.72,4.41,3.59,7.39-.03.8,1.21.99,1.25.19.14-3.35-1.58-6.01-3.84-8.35h0Z"
      fill="#4f2b1b"
    />
    <path
      d="m70.82,57.71c.06-.35-.17-.68-.52-.74-1.93-.24-5.41-1.07-6.55,1.11-.39.68.77,1.21,1.15.5.71-1.33,4.04-.5,5.18-.35.35.06.68-.17.74-.52Z"
      fill="#4f2b1b"
    />
    <path
      d="m43.89,22.71c2.17,4.63,2.43,8.65,1.42,13.58-.24,1.16,1.58,1.42,1.82.27.51-2.44,1.17-5.01,2.68-7.04,2.5-3.36,6.28-3.19,9.91-1.89l-.48-1.21c-.78,1.32-1.68,3.23-3.17,3.89-1.23.55-2.99.18-4.28.08-1.17-.09-1.45,1.72-.27,1.82,1.82.14,3.96.51,5.65-.39,1.78-.94,2.78-3.01,3.76-4.67.24-.41-.06-1.06-.48-1.21-3.74-1.34-7.88-1.76-10.97,1.19-2.5,2.38-3.48,5.89-4.17,9.16l1.82.27c1.08-5.26.78-9.62-1.53-14.55-.5-1.07-2.2-.37-1.7.7h0Z"
      fill="#4f2b1b"
    />
    <path
      d="m32.05,45.08c.08-2.26.43-4.41.88-6.06,1.42-5.13,5.4-7.31,9.91-4,1.47,1.08,1.41,3.01,2.86,3.69.42.2.93.11,1.3-.16l.85-.62c1.35-.98-.22-3.04-1.57-2.06.07-.05,1.44,1.63.67-.19-.25-.6-.73-1.07-1.16-1.54-1.38-1.5-3.48-2.64-5.44-3.12-5.99-1.48-9.29,3.58-10.3,8.85-.22,1.14-.39,2.43-.48,3.8l2.49,1.41Z"
      fill="#4f2b1b"
    />
    <path
      d="m57.74,39.75c-.59-1.45-1.78-2.69-3.81-3.08-1.92-.37-4.56-.04-6.09,1.26-1.28,1.08-2.83-.99-1.57-2.06,2.63-2.22,7.38-2.53,10.41-1.05,1.61.78,2.66,1.93,3.29,3.28l-2.23,1.64Z"
      fill="#4f2b1b"
    />
    <path
      d="m33.79,49.54c2.46,5.28,1.83,11.48-1.64,16.16-1.8,2.71-2.8,2.59-6.55,2.22-7.98-.73-16.85-9.18-12.76-17.66,1.89-3.39,5.11-5.84,8.89-6.73,5.31-1.29,9.4,1.53,12.04,6,.29.37.83.43,1.2.14.3-.24.4-.64.26-1-4.89-8.19-14.41-9.33-21.35-2.59-6.94,6.74-3.01,17.37,4.59,21.49,3.48,1.94,10.87,3.96,13.98.55,4.72-5.35,5.81-12.99,2.78-19.45-.46-.97-1.89-.11-1.43.87Z"
      fill="#4f2b1b"
    />
    <path
      d="m28.15,44.59c2.13,5.37-12.32,13.38-15.18,8.55s11.93-13.24,15.28-8.35c.61.88,2.06.02,1.45-.86-2.42-3.53-7.9-1.97-11.04-.47s-9.75,6.02-7.5,10.4c1.78,3.56,7.36,2.11,10.14.99,3.66-1.5,10.38-5.87,8.5-10.64-.41-1.1-1.97-.74-1.64.37Z"
      fill="#4f2b1b"
    />
    <path
      d="m16.31,59.58c-.35-1.39-.53-2.82-.55-4.26-.07-.46-.51-.78-.97-.71-.38.06-.67.36-.71.74.02,1.58.22,3.15.62,4.68.2.42.71.61,1.13.4.33-.16.52-.5.48-.86Z"
      fill="#4f2b1b"
    />
    <path
      d="m33.05,50.1c-.76-1.55-2.2-2.66-3.89-2.99-.45-.11-.9.17-1.01.62s.17.9.62,1.01c1.22.24,2.26,1.06,2.78,2.19.48.98,1.91.12,1.45-.86l.06.03Z"
      fill="#4f2b1b"
    />
    <path
      d="m19.42,60.91c-.66-1.79-1.04-3.68-1.14-5.59-.07-.46-.51-.78-.97-.71-.38.06-.67.36-.71.74.1,2.06.5,4.09,1.2,6.03.34,1.01,1.95.55,1.63-.48Z"
      fill="#4f2b1b"
    />
    <path
      d="m33.15,53.72c-1.19-2.04-2.94-3.68-5.05-4.74-.98-.4-1.82,1.06-.82,1.47,1.82.91,3.33,2.33,4.37,4.08.6.9,2.04.06,1.44-.84l.06.03Z"
      fill="#4f2b1b"
    />
    <path
      d="m23.02,59.43c-.72-1.64-1.27-3.35-1.64-5.1-.2-1.06-1.82-.6-1.61.46.37,1.75.92,3.46,1.64,5.1.42,1,2.03.54,1.61-.46Z"
      fill="#4f2b1b"
    />
    <path
      d="m29.47,56.41c-.8-1.91-1.99-3.63-3.49-5.05-.33-.32-.86-.32-1.18,0s-.32.86,0,1.18c1.3,1.2,2.35,2.66,3.07,4.28.42,1,2.03.54,1.61-.46l-.02.04Z"
      fill="#4f2b1b"
    />
    <path
      d="m71.23,34.93c.14.25.24.44.38.69-1.65,1.51-2.38,3.58-3.32,5.53-1.82,3.77-3.64,7.54-5.4,11.33-.77,1.66-1.42,3.38-2.09,5.09-.93,2.36-1.93,4.69-3.27,6.85-1.69,2.72-3.79,5.04-6.61,6.65-1.19.68-2.44,1.2-3.81,1.38-2.68.36-4.9-.54-6.76-2.47-.43-.44-.91-.85-1.42-1.18-2.85-1.84-4.15-4.8-3.54-8.16.54-2.97,1.97-5.51,3.92-7.77,1.82-2.1,3.94-3.87,6.31-5.29,6.25-3.75,11.99-8.22,17.88-12.47.66-.47,1.32-.93,1.94-1.45.59-.49,1.14-1.04,1.7-1.57-.05-.08-.1-.15-.14-.23.23.05.46.1.76.17.56-.68,1.15-1.37,1.73-2.08,6.29-7.67,12.58-15.34,18.86-23,.07-.09.14-.17.21-.26.74-.87,1.27-.94,2.14-.24.46.37.9.75,1.35,1.13,1.06.89,1.11,1.33.24,2.36-2.72,3.23-5.45,6.45-8.18,9.68-4.29,5.08-8.57,10.16-12.91,15.3Zm-30.62,31.94c7.55-9.08,15-18.03,22.45-26.98.12-.14.21-.3.31-.45.02-.02.02-.07,0-.1-.01-.03-.05-.05-.09-.09-.09.04-.2.08-.27.14-5.15,4.43-10.33,8.83-15.43,13.33-1.89,1.67-3.6,3.56-5.34,5.41-1.04,1.1-1.86,2.37-2.31,3.84-.51,1.66-.4,3.24.67,4.89Zm1.49.9c.3.1.46.18.63.21,1.44.26,2.77-.07,4.01-.79,1.13-.66,2.07-1.53,2.85-2.56,1.22-1.61,2.49-3.19,3.53-4.91,3.24-5.33,6.38-10.72,9.55-16.09.1-.16.12-.36.18-.55-.05-.03-.1-.05-.15-.08-6.85,8.23-13.69,16.45-20.61,24.77Zm.99,2.11c.97.77,2.08.99,3.27.92,1.47-.09,2.78-.64,4.02-1.39,2.41-1.46,4.31-3.46,5.68-5.89,1.1-1.94,2.09-3.97,2.91-6.04,1.28-3.25,2.66-6.44,4.19-9.58,1.04-2.15,2.06-4.3,3.09-6.46.15-.31.28-.62.42-.93-.62.71-1.09,1.5-1.55,2.29-2.74,4.73-5.45,9.49-8.24,14.2-1.87,3.16-3.86,6.26-6.25,9.06-1.97,2.3-4.31,3.88-7.54,3.83Zm13.48-27.32s-.07-.09-.1-.14c-.2.13-.39.26-.59.39-2.81,1.87-5.6,3.76-8.43,5.6-1.94,1.27-3.84,2.57-5.52,4.18-1.93,1.85-3.48,3.97-4.38,6.52-.39,1.11-.66,2.26-.59,3.45.07,1.05.28,2.07,1.05,3.01-.02-.68-.06-1.22-.06-1.76-.02-2.24.87-4.16,2.23-5.84,1.1-1.37,2.25-2.73,3.54-3.91,3.94-3.62,7.97-7.16,11.96-10.73.29-.26.58-.52.88-.77Z"
      fill="#85c441"
    />
    <path
      d="m88.06,57.57c-.92,19.53-18.05,38.25-41.53,37.41-22.96-.83-37.98-19.78-38.61-37.4,26.69,8.67,53.38,8.67,80.14,0Z"
      fill="#85c441"
    />
  </svg>
</template>
